import React from "react";
import { AlertCircleOutlined } from "@phonepe/enigma-ui-icons";
export const FILTER_TYPES = {
    checkbox: "checkbox",
    radio: "radio",
    list: "list",
    dateRange: "dateRange",
    custom: "custom",
} as const;

export const FILTER_MODAL_DATA_IDS = {
    MODAL: "filter-modal",
    TITLE: "filter-modal-title",
    FILTER_TYPES: "filter-modal-filter-types",
    ACTIVE_FILTER_TYPE: "filter-modal-active-filter-type",
    FILTER_TYPE_TITLE: "filter-modal-filter-type-title",
    CROSS_BUTTON: "filter-modal-cross-button",
    APPLY_BUTTON: "filter-modal-apply-button",
    CLEAR_ALL_BUTTON: "filter-modal-clear-all-button",
    NO_RESULT_WRAPPER: "filter-modal-no-result-wrapper",
    LOADING_WRAPPER: "filter-modal-loading-wrapper",
    CUSTOM_RENDERER_WRAPPER: "filter-modal-custom-renderer-wrapper",
    // Checkbox dataIds
    CHECKBOX_GROUP: "filter-modal-checkbox-group",
    CHECKBOX_SELECT_ALL: "filter-modal-checkbox-select-all",
    CHECKBOX_INPUT: "filter-modal-checkbox-input",
    CHECKBOX_OPTION: "filter-modal-checkbox-option",
    // Checkbox dataIds
    RADIO_GROUP: "filter-modal-radio-group",
    RADIO_INPUT: "filter-modal-radio-input",
    RADIO_OPTION: "filter-modal-radio-option",
    // InlineSearchSelect dataIds
    AUTOCOMPLETE_WRAPPER: "filter-modal-autocomplete-wrapper",
    AUTOCOMPLETE_OPTION: "filter-modal-autocomplete-option",
    AUTOCOMPLETE_INPUT: "filter-modal-autocomplete-input",
    AUTOCOMPLETE_NOT_FOUND_WRAPPER:
        "filter-modal-autocomplete-not-found-wrapper",
    DATE_PICKER_START_TIME: "date-picker-start-time",
    DATE_PICKER_END_TIME: "date-picker-end-time",
};

export const FILTERS_DISPLAY_DATE_FORMAT = "DD MMM YYYY";
export const FILTERS_TIME_FORMAT = "HH:mm";
export const FILTERS_TIME_FORMAT_TWELVE_HOUR = "h:mm A";
export const FILTERS_FUNCTIONAL_DATE_FORMAT = "YYYY-MM-DD";
export const START_INPUT = "startInput";
export const END_INPUT = "endInput";
export const MAX_ALLOWED_DATE_RANGE = 396;

export const TIMEPICKER_COMMON_PROPS = {
    inputReadOnly: true,
    showNow: false,
    format: FILTERS_TIME_FORMAT_TWELVE_HOUR,
    allowClear: false,
    use12Hours: true,
};

export const DATE_FILTER_OPTIONS = {
    past6months: {
        value: "past6months",
        key: "past6months",
        title: "Past 6 Months",
    },
    past3months: {
        value: "past3months",
        key: "past3months",
        title: "Past 3 Months",
    },
    month: { value: "month", key: "month", title: "This Month" },
    week: { value: "week", key: "week", title: "This Week" },
    yesterday: { value: "yesterday", key: "yesterday", title: "Yesterday" },
    today: { value: "today", key: "today", title: "Today" },
    tomorrow: { value: "tomorrow", key: "tomorrow", title: "Tomorrow" },
    custom: { value: "custom", key: "custom", title: "Custom" },
} as const;

export const FILTER_MESSAGES = {
    INVALID: {
        title: "Unable to load filters",
        description: "We are unable load filters at this moment",
        icon: <AlertCircleOutlined width={30} height={30} />,
        showRefreshText: true,
    },
    EMPTY: {
        title: "No filter available",
        description:
            "There are no filter available for the selected filter type.",
        showRefreshText: false,
        icon: null,
    },
};
